<ul *ngIf="displayOverlay && userText.length > 0" class="pa-autocomplete-overlay">
    <li class="pa-autocomplete-close-bar">
        <div (click)="closeAutocompleteOverlay()" class="pa-autocomplete-item-input-close"></div>
    </li>
    <li (click)="sendMessage(userText, 'text')" [title]="userText" class="pa-autocomplete-item-input">
        <span>{{ userText }}</span>
    </li>
    <li *ngIf="values.length === 0" class="pa-autocomplete-no-items">
        {{'AUTOCOMPLETE.HINT_NO_ENTRIES' | translate }}
    </li>
    <li (click)="sendMessage(value, 'text')" *ngFor="let value of values" [title]="value" class="pa-autocomplete-item">
        <span>{{ value }}</span>
    </li>
</ul>
<div *ngIf="inputOptionsComponent?.validation !== undefined" class="pa-meta pa-validation-error">
    <div *ngIf="userText.length > 0 && !validateText(userText)">
        {{inputOptionsComponent.validation.errorMessage}}
    </div>
</div>
<div class="pa-input">
    <div #messageInput (focusin)="onFocusIn()" (keydown)="onEnterPressed($event)" (keyup)="onKeyUp()"
         [(contenteditableModel)]="userText" [attr.placeholder]="'PLACEHOLDER' | translate"
         [class.pa-message-input-validation-error]="inputOptionsComponent?.validation !== undefined && userText.length > 0 && !validateText(userText)" [maxLength]="inputOptionsComponent?.maxInputLength" class="pa-message-input"
         contenteditable="true">
    </div>
    <button (click)="sendUserText()" [disabled]="!canSendMessage()" class="pa-send-button" type="button">
        <svg aria-hidden="true" class="pa-send-button-icon" data-fa-processed="" data-icon="paper-plane"
             data-prefix="fas" role="img" viewBox="0 0 512 512">
            <path d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                  fill="currentColor"></path>
        </svg>
    </button>
</div>
<div *ngIf="inputOptionsComponent?.maxInputLength !== 0" class="pa-meta">
    <div [class.pa-letter-count-full]="userText.length === inputOptionsComponent?.maxInputLength"
         class="pa-letter-count">
        {{'CHARACTER_INDICATOR' | translate:{
        length: userText.length,
        maxLength: inputOptionsComponent?.maxInputLength
    } }}
    </div>
</div>
